import {Observable} from 'rxjs';

export abstract class ProxyStreamService {
    abstract mediaFileStreaming(signedUrl: string): Observable<Blob>;
}
